export const createBlog = (blog) => {
  const blogTitle = document.querySelector('[data-blog-title]');

  if (blogTitle)
    blogTitle.innerText = blog.title;
}